const ISLIVE = process.env.REACT_APP_IS_LIVE === '1'

export const BaseUrls: any = {
	API_SERVER: {
		url: ISLIVE ? process.env.REACT_APP_API_BASE_URL_LIVE : process.env.REACT_APP_API_BASE_URL_UAT
	},
}

export const REACT_APP_CDN_URL = process.env.REACT_APP_CDN_URL;